<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Diskaun"
        :crumbs="crumbs"
    >
        <z-page :title="`Senarai Diskaun (${total})`" :append-button="true">
            <w-flex column :gap="3">
                <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input v-model="searchParams.no_hm"
                                >No. HM</w-input
                            >

                            <w-button
                                :loading="loading"
                                class="align-self-end"
                                type="submit"
                            >
                                TAPIS
                            </w-button>
                        </w-flex>
                    </w-flex>
                </w-form>
                <w-flex class="justify-space-between">
                             <w-button class="align-self-end" @click="semakHakmilik" :loading="loading">
                                 Daftar Diskaun Berkelompok&nbsp;
                                 <w-icon> fal fa-plus </w-icon>
                             </w-button>
                </w-flex>
                <Table
                    :headers="diskaun.headers"
                    :items="loading ? [] : diskaun.items"
                    :loading="loading"
                >
                    <template #item-cell.id="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>

                    <template
                        #item-cell.tarikh_mula="{ item, label, header, index }"
                    >
                    <div v-if="item.tarikh_mula!=null">
                        {{ moment(item.tarikh_mula).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Mula
                    </div>
                    </template>

                    <template
                        #item-cell.tarikh_tamat="{ item, label, header, index }"
                    >
                    <div v-if="item.tarikh_tamat!=null">
                        {{ moment(item.tarikh_tamat).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Tamat
                    </div>
                    </template>

                    <template
                        #item-cell.file="{ item, label, header, index }"
                    >
                        <w-button v-if="item.file"
                            @click="dokumen(item.file)"
                        >
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-file </w-icon>
                                </template>
                                Papar
                            </w-tooltip>
                        </w-button>
                        <h1 v-else>Tiada</h1>
                    </template>
                    <template
                        #item-cell.action="{ item, label, header, index }"
                    >
                        <inertia-link
                            :href="$route('cukai-tanah.kemaskiniAmpun')"
                            :data="{ no_hm: item.no_hm }"
                        >
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-pencil </w-icon>
                                </template>
                                Papar
                            </w-tooltip>
                        </inertia-link>
                    </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage"
                    :currentPage="pagination.currentPage"
                    :perPage="pagination.perPage"
                    @onClick="onPaginationChange($event)"
                />
            </w-flex>
        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="900"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <w-card>
                <center><h2>Daftar Diskaun Kelompok (CUKAI SEMASA)</h2></center>
                <br><br>
                <w-form  @submit.prevent="daftarDiskaun">
                     <center>
                        <w-select
                        :items="districts"
                        class="xs3"
                        outline
                        readonly="readonly"
                        v-model="form.kod_daerah">


                        </w-select>
                     </center>
                    <w-flex>
                        <div class="xs6 pa1">
                            <w-input
                                class="py3"
                                label="No Rujukan"
                                label-position="left"
                                v-model="form.no_rujukan"
                                :validators="[validators.required]"
                                outline>

                            </w-input>
                        </div>
                        <div class="xs6 pa1">
                            <w-input
                                class="py3"
                                type="text"
                                label="Kod"
                                label-position="left"
                                v-model="form.kod"
                                :validators="[validators.required]"
                                outline>
                            </w-input>
                        </div>
                    </w-flex>
                    <w-flex>
                        <div class="xs6 pa1">
                            <w-input
                                class="py3"
                                type="number"
                                label="Amaun"
                                label-position="left"
                                v-model="form.amaun"
                                :validators="[validators.required]"
                                outline>

                            </w-input>
                        </div>
                        <div class="xs6 pa1">
                            <w-input
                                class="py3"
                                label="Keterangan"
                                label-position="left"
                                v-model="form.keterangan"
                                :validators="[validators.required]"
                                outline>
                            </w-input>
                        </div>
                    </w-flex>
                    <w-flex>
                        <div class="xs6 pa1">
                            <w-input
                                class="py3"
                                type="date"
                                label="Tarikh Mula"
                                label-position="left"
                                v-model="form.tarikh_mula"
                                :validators="[validators.required]"
                                outline>
                            </w-input>
                        </div>
                        <div class="xs6 pa1">
                            <w-input
                                class="py3"
                                type="date"
                                label="Tarikh Tamat"
                                label-position="left"
                                v-model="form.tarikh_tamat"
                                :validators="[validators.required]"
                                outline>
                            </w-input>
                        </div>
                    </w-flex>
                    <div class="d-flex justify-end mt3">
                         <w-button class="my1 mr0" type="submit" :loading="loading">
                             Daftar Diskaun Kelompok
                         </w-button>
                     </div>
                </w-form>
            </w-card>
        </w-dialog>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";
import Table from "../Component/Table";
import TablePagination from "../Component/TablePagination";
import SemakHakMilikForm from "../Component/SemakHakMilikForm";

export default {
    extends: ZResource,
    components: { Table, TablePagination, SemakHakMilikForm },
    data() {
        return {
            validators: {
              required: (value) => !!value || "Sila Isi Ruangan Ini",
            },
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            total: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                lastPage: 1,
            },
            statusOptions: [
                { value: "null", label: "Semua" },
                { value: "1", label: "Aktif" },
                { value: "0", label: "Tidak Aktif" },
            ],

            diskaun: {
                headers: [
                    { label: "No. Rujukan", key: "no_hm" },
                    { label: "No. Hakmilik", key: "pemilik" },
                    { label: "No. Akaun", key: "keluasan" },
                    { label: "Keterangan", key: "no_tauliah" },
                    { label: "Nama Pemilik", key: "no_kp" },
                    { label: "Tempoh Mula", key: "tarikh_mula" },
                    { label: "Tempoh Tamat", key: "tarikh_tamat" },
                    { label: "Status", key: "status" },
                    { label: "Tindakan", key: "action", align: "center" },
                ],
                items: [],
            },
            searchParams: {
                no_hm: null,
            },
            dialog:{
                show: false
            },
            searching: false,
            hasSearched: false,
            form: {
                kod_daerah: "03",
                no_rujukan:null,
                kod:null,
                amaun:null,
                keterangan:null,
                tarikh_mula:null,
                tarikh_tamat:null,
            },
            districts: [],
            hm:[]
        };
    },
    methods: {
        async daftarDiskaun(){
            if(this.form.amaun!==null && this.form.no_rujukan !==null
            && this.form.kod!==null && this.form.keterangan!==null && this.form.tarikh_mula!==null
            && this.form.tarikh_tamat!==null){

            // console.log(this.form);
            this.searching = true;
            this.loading=true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/diskaunDaftar`,
                responseType: "json",
                data: this.form,
            }).then((e) => {
                console.log(e);
                this.$waveui.notify({
                        success: true,
                        message: `Diskaun Dijana`,
                        timeout: 3000,
                    });
                })
                .finally((e) => {
                    this.searching = false;
                    this.hasSearched = true;
                    this.dialog.show=false;
                });
            }
            else{
                this.$waveui.notify({
                        error: true,
                        message: "Sila Isi Semua Maklumat",
                        timeout: 3000,
                    });

            }
            this.loading = false;
        },
        async onSemak(e){
            this.searching = true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    this.hm = e.data;
                    if (e.data.length > 0) {
                        const url = `ampunHasil?no_hm=${this.hm[0].no_hm}`;
                        this.$inertia.get(url);
                    }

                })
                .finally((e) => {
                    this.searching = false;
                    this.hasSearched = true;
                });
        },
        semakHakmilik(){
            this.dialog.show = true;
        },
        moment(date) {
            return moment(date);
        },
        onPaginationChange(e) {
            this.pagination.currentPage = e.value.currentPage;
            this.pagination.perPage = e.value.perPage;
            this.fetchData2();
        },
        filter() {
            this.searchParams.status =
                this.searchParams.status === "null"
                    ? null
                    : this.searchParams.status;
            this.fetchData2();
        },
        async fetchData2() {
            this.searchParams.limit = this.pagination.perPage;
            this.searchParams.offset =
                (this.pagination.currentPage - 1) * this.pagination.perPage;
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                const { limit, offset, total, data } = e.data;
                this.total = total;
                this.pagination.lastPage = Math.ceil(total / limit);
                this.diskaun.items = data;
            });

            this.loading = false;
        },
        async fetchDaerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });

            });
        },
        async jabatanToDaerah(){
            await axios({
                method:"get",
                url: `${this.apiBaseUrl}/jabatanToDaerah?jabatan=${this.$page.props.auth.user.jabatan_id}`,
                responseType:'json',
            }).then((e)=>{
                this.form.kod_daerah=e.data[0].kod_daerah;
                })
        },
    },
    computed: {
        getLastPage() {
            return this.total > 0
                ? Math.ceil(this.total / this.pagination.perPage)
                : 1;
        },
        getSearch(){

        },
    },
    mounted() {
        // this.fetchData2();
        this.fetchDaerah();
        this.jabatanToDaerah();
    },
};
</script>
